export default [
  {
    path: 'staffs',
    name: 'staffs',
    component: () => import('@/views/staff/Staffs'),
    props: { role: 'staffs' },
    meta: {
      title: 'Người dùng',
      auth: true,
      permission: 'view-staff-list',
    },
  },
  {
    path: 'staff/:id',
    name: 'staff',
    component: () => import('@/views/staff/Staff'),
    meta: {
      title: 'Người dùng',
      auth: true,
    },
  },
]
